import React from "react";
// import users from "../../db2.json";
import { Link } from "react-router-dom";
import { VIEW_BOOKING } from "../Constant/Constants";
import { useTranslation } from "react-i18next";

export default function Viewbooking() {
    const {t} = useTranslation()
//   console.log(users);
  return (
    <>
      <div className="view_booking">
        <Link to={VIEW_BOOKING}>
          <button className="button_view_booking">{t("Viewbooking")}</button>
        </Link>
      </div>
    </>
  );
}
